import React, { FunctionComponent } from 'react';
import { Link } from 'gatsby';
import { formatLink } from '../../utils/formatLink';
import { formatDate } from '../../utils/formatDate';
import { InternalLinkIcon } from '../Icons';
import { urlFor } from '../../utils/imageBuilder';
import { SanityImage, SanitySlug, SanityTeaser } from '../../types/common';
import RichText from '../RichText';
import { useScreenSize } from '../../hooks/useScreenSize';
import './styles.scss';

type VideoPreviewProps = {
  video: {
    _id: string;
    _createdAt: string;
    title: string;
    _rawDescription: any;
    slug: SanitySlug;
    image: SanityImage;
    teaser?: SanityTeaser | null;
  };
}

const VideoPreview: FunctionComponent<VideoPreviewProps> = ({ video }) => {
  const { isMobile } = useScreenSize();

  return (
    <Link
      to={formatLink(video)}
      className='video-preview'
    >
      <img
        src={urlFor(video.teaser?.image?.asset ? video.teaser.image : video.image).width(isMobile ? 100 : 150).quality(90).url()}
        alt={video.teaser?.image?.alt ? video.teaser.image.alt : video.image.alt}
      />
      <div>
        <h4>{video.teaser?.title ? video.teaser.title : video.title}</h4>
        <div className='video-preview-description'>
          {video.teaser?.description ? (
            <p>{video.teaser.description}</p>
          ) : (
            <RichText
              value={video._rawDescription}
            />
          )}
        </div>
        <span>{formatDate(video._createdAt)}</span>
      </div>
      <InternalLinkIcon />
    </Link>
  );
}

export default VideoPreview;
